export default {
  // Common words
  enter: "Enter",
  next: "Next",
  previous: "Previous",
  finish: "Finish",
  returnToWebsite: "Return to Website",
  complete: "Complete",
  submit: "Submit",
  cancel: "Cancel",
  yes: "Yes",
  no: "No",
  skip: "Skip",
  close: "Close",
  discard: "Discard",
  save: "Save",
  "thank-you": "Thank You",
  select: "Select",
  hi: "Hi",
  hello: "Hello",
  link: "Link",
  back: "Back",
  view: "View",
  continue: "Continue",
  of: "of",

  // Client Survey Main
  "client-survey-main-thanks-note":
    "Thanks for taking the time, your feedback shapes our offer <br /> for the future.",
  "client-survey-how-likely-recommend":
    "How likely would you be to recommend us to others?",
  "client-survey-how-likely-note":
    "On a scale 0 - 10, where 0 is not at all likely and 10 is extremely likely.",
  "client-survey-how-likely-recommend-question":
    "What is the one thing that we could to to make you more likely to recommend us?",
  "step-of": "Step {step} of {total}",
  step: "Step {step}",
  "client-survey-how-satisfied-with-service":
    "How satisfied are you with the service",
  "client-survey-how-satisfied-with-service-question":
    "What is the one thing that we could do to improve?",
  "client-survey-how-satisfied-with-food":
    "How satisfied are you with the food you receive from us?",
  "client-survey-how-satisfied-with-food-question":
    "What is the one thing that we could do to improve?",
  "client-survey-what-is-the-best-thing-about-working-with-us":
    "What is the best thing about working with us? Please select all that matters.",
  "management-team": "Management Team",
  "the-front-line-operations-team": "The front line operations team",
  "food-offering": "Food Offering",
  innovation: "Innovation",
  communication: "Communication",
  "flexibility-and-responsiveness": "Flexibility and Responsiveness",
  billing: "Billing",
  "health-and-hygiene-standards": "Health and Hygiene Standards",
  "if-other-please-specify": "If other, please specify...",
  "based-on-the-service-we-provide-where-can-we-improve-the-most-please-select-all-that-matters":
    "Based on the service we provide, where can we improve the most? Please select all that matters.",
  "please-can-we-have-some-more-detail": "Please can we have some more detail?",
  "to-help-us-understand-your-csr-priorities-please-order-in-rank-of-importance-the-following":
    "To help us understand your CSR priorities, please order in rank of importance the following:",
  "sustainable-ingredients": "Sustainable Ingredients",
  "food-waste": "Food Waste",
  "local-sourcing": "Local Sourcing",
  "people-and-communities": "People &amp; Communities",
  "energy-reduction": "Energy Reduction",
  "working-with-local-communities": "Working with local communities",
  "environmental-choices": "Environmental Choices",
  "meat-free": "Meat Free",
  "less-plastic": "Less Plastic",
  "would-you-like-to-be-contacted-about-your-feedback":
    "Would you like to be contacted about your feedback? If so, please leave your contact information below",
  "full-name": "Full Name",
  "email-address": "Email Address",
  "phone-number": "Phone Number",
  feedback: "Feedback",
  "view-our-privacy-policy": "View our Privacy Policy",
  "thank-you-for-taking-time-to-complete-the-survey":
    "Thank you for taking time to complete the survey!",

  // 404 Not Found
  "404-not-found": "404 Not Found",

  // Privacy Policy
  "privacy-policy": "Privacy Policy",

  // Employee Web Rating Feedback Step 1
  "employee-web-rating-feedback-step-1-positive":
    "Glad to hear you're feeling positive, we'd love to know why?",
  "employee-web-rating-feedback-step-1-negative":
    "Sorry to hear you're not feeling the best, please can you tell us why?",

  // Employee Web Rating Feedback Step 2
  "employee-web-rating-feedback-step-2-heading":
    "Is there anything else you'd like to share with us today?",
  "employee-web-rating-feedback-step-2-information":
    "Do you have any comments or feedback about your experience with us today?",
  "employee-web-rating-feedback-step-2-placeholder":
    "Share us your experience with us today...",

  // Employee Web Rating Feedback Step 3
  "employee-web-rating-feedback-step-3-heading":
    "Would you like to give kudos to someone?",
  "no-employees-found": "No Employees Found",

  // Employee Web Rating Home
  "choose-location": "Choose Location",
  "search-location": "Search Location",
  "feedback-anonymous": "Do you want to keep your feedback anonymous?",
  "feedback-feeling-today": "How are you feeling today?",

  // Employee Web Rating Thankyou Page
  "thank-you-for-your-feedback": "Thank You For Your Feedback!",
  "back-to-home": "Back To Home",
  page: "Page",

  // Feedback Once Alert
  "feedback-once-alert": "Feedback has been given once from this URL.",

  // Front Customer Audit
  "please-answer-above-question": "Please answer the above question.",
  "add-comments": "Add Comments",
  "enter-answer": "Enter Answer",
  "add-upload-files": "Add Upload Files",

  // Alphega Questions
  "did-you-buy-medicine-in-the-pharmacy-today":
    "Did you buy medicine in the pharmacy today?",
  "were-you-asked-any-of-the-following": "Were you asked any of the following:",
  "who-is-the-medicine-for": "Who is the medicine for?",
  "what-are-your-symptoms": "What are your symptoms?",
  "how-long-you-had-the-symptoms": "How long you had the symptoms?",
  "what-action-you-have-already-taken": "What action you have already taken?",
  "are-you-taking-any-other-medication": "Are you taking any other medication?",

  // Alphega - Other Companies Questions
  "did-you-wait-more-than-10-minutes-to-be-served":
    "Did you wait more than 10 minutes to be served?",
  "were-the-products-you-wanted-in-stock":
    "Were the products you wanted in stock?",
  "were-the-staff-friendly-and-helpful": "Were the staff friendly and helpful?",
  "did-you-receive-any-advice-about-your-medicines":
    "Did you receive any advice about your medicines?",

  // Front Mobile Home
  "how-was-your-experience-with-us-today":
    "How was your experience with us today?",

  // Front Mobile Thankyou Page
  "thank-you-for-your-time-and-your-answers":
    "Thank you for your time and your answers.",
  "would-also-like-to-rate-us-on-google":
    "Would also like to rate us on Google?",
  "rate-us-now": "Rate us now",

  // Negative Chat Reply
  "select-skill": "Select Skill",
  "none-selected": "None Selected",
  "can-we-get-in-touch-with-you-about-your-experience-today":
    "Can we get in touch with you about your experience today?",
  "write-here": "Write here...",
  "please-can-we-get-your-name": "Please can we get your name?",
  "please-enter-your-email": "Please enter your email:",
  "enter-your-phone-number": "Enter your phone number:",
  "please-tell-us-a-bit-more-about-your-experience":
    "Please tell us a bit more about your experience:",
  "you-have-already-submitted-rating": "You have already submitted rating",
  "sorry-to-hear-you-didn-t-have-the-best-experience-today-with-us-please-could-you-highlight-what-went-wrong":
    "Sorry to hear you didn't have the best experience today with us, please could you highlight what went wrong?",

  // Positive Chat Reply
  "select-employee": "Select Employee",
  "we-d-love-to-know-who-looked-after-you-today":
    "We'd love to know who looked after you today?",
  "what-stood-out-to-you-today": "What stood out to you today?",
  "did-we-provide-exceptional-service-today":
    "Did we provide exceptional service today?",
  "do-you-have-any-comments-or-feedback-about-your-experience-with-us-today":
    "Do you have any comments or feedback about your experience with us today?",

  // Client Connect Director
  "message-from-leadership": "Message from Leadership",
  "message-from-leadership-text":
    "I am constantly seeking ways to better our offerings for our clientele. Are there aspects we could better in your opinion?",
  "client-connect-director-another-note":
    "On another note, if there's a specific topic you'd like our team to address, don't hesitate to share. I'm not just here to listen, but to engage and act upon your concerns or ideas.",
  "your-message-here": "Your message here",
  "visit-information": "Visit Information",
  "visit-time-out": "Visit Time Out",
  "contact-information": "Contact Information",
  "client-connect-director-contact-information-text":
    "To provide enhanced assistance, we kindly ask for your details, including your name, email address, and contact number. This information will enable us to respond promptly and contact you.",
  name: "Name",
  "enter-your-name": "Enter your name",
  email: "Email",
  "enter-your-email": "Enter your email",
  "contact-number": "Contact Number",
  "please-enter-your-name": "Please enter your name",
  "please-enter-your-email-or-phone-number":
    "Please enter your email or phone number",
  "invalid-email-address": "Invalid email address",
  "invalid-phone-number-format":
    "Invalid phone number for the selected country.",
  "no-match-found": "No match found",
  "phone-number-must-be-digits-for-country":
    "Phone number must be {count} digits for the selected country ({current}/{count}).",
  "phone-number-must-be-digits-range-for-country":
    "Phone number must be {min}–{max} digits for the selected country ({current}/{max}).",
  "please-select-time": "Please select time",
  "you-must-provide-at-least-one-answer-before-submitting-the-survey":
    "You must provide at least one answer before submitting the survey.",

  // Mobile Survey Questions CheckBoxType
  comment: "Comment",
  "comment-is-required": "Comment is Required!",
  "minimum-selection-is": "Minimum selection is {min_options}",
  "maximum-selection-is": "Maximum selection is {max_options}",
  "this-question-is-required": "This Question is Required!",
  "please-fill-all-required-grid-rows": "Please fill all required grid rows!",
  "please-fill-mandatory-fields-to-continue":
    "Please fill out the mandatory fields to continue",

  // Mobile Survey Questions CommentsAndImage
  "please-select-valid-image-files": "Please select valid image files.",

  // Mobile Survey Questions EmployeeType
  loading: "Loading",
  "getting-employee": "Getting employee...",

  // Mobile Survey Questions FileUploadType
  "please-select-valid-image-or-video-files":
    "Please select valid image or video files.",
  "please-select-a-valid-file":
    "Please select a valid file (image, video, PDF, or Word).",

  // Mobile Survey Questions NumberType
  "please-enter-a-number-without-any-decimal-points":
    "Please enter a number without any decimal points.",
  "please-enter-a-number-less-than-or-equal-to":
    "Please enter a number less than or equal to {max_number_value}.",

  // Mobile Survey Questions SignatureType
  "please-complete-your-signature": "Please complete your signature.",

  // Mobile Survey Questions TextType
  "please-enter-valid-email-address": "Please enter valid email address.",
  "phone-number-should-be-10-digit": "Phone number should be 10 digits.",
  "please-enter-at-least-characters":
    "Please enter at least {minimum_character} characters.",
  "select-date": "Select Date",
  "select-time": "Select Time",
  "client-connect-date-picker-aria": "Date: {value}. Open date picker",
  "client-connect-time-picker-aria": "Time: {value}. Open time picker",
  "select-country": "Select Country",

  // Report Page
  "click-the-link-to-see-how": "Click the link to see how.",
  "adding-your-teams-to-the-ServeFirst-reporting-platform":
    "That by adding your teams to the ServeFirst reporting platform that they can also login to see their performance, also; you have the ability to manage your team and access additional reports to understand how you're performing overall -",
  "did-you-know": "Did you know..",
  count: "count",
  average: "average",
  focus: "focus",
  performance: "Performance",
  "you-can-create-bespoke-action-plans":
    "You can create bespoke action plans that filter directly into here if created within your ServeFirst account, here you can create actions, timelines and owners instantly whilst tracking performance. -",
  "no-of-times-raised": "No. of Times Raised",
  action: "Action",
  "attribute-name": "Attribute Name",
  "action-plan": "Action Plan",
  "that-by-adding-your-teams-to-the-ServeFirst-reporting-platform":
    "That by adding your teams to the ServeFirst reporting platform that they can also login to see their performance, also; you have the ability to manage your team and access additional reports to understand how you're performing overall -",
  result: "Result",
  category: "Category",
  "your-location-vs-all-location": "Your Location vs. All Location",
  "net-promoter-score": "Net Promoter Score",
  "responses-breakdown": "Responses Breakdown",
  "trended-net-promoter-score": "Trended Net Promoter Score",
  "trended-results": "Trended Results",
  "net-promoter-score-info":
    "Net Promoter Score is based around % of promoters (Score a 5/5) - % of Detractors (Score a 1, 2 or 3), you can find out more about Net Promoter Score by clicking on the following",
  "customer-feedback": "Customer Feedback",
  logan: "Logan",
  "top-performer": "Top Performer",
  "rank-in-the-country": "Rank in the Country",
  "ytd-score": "YTD Score",
  "score-during-period": "Score During Period",
  "0-from-last-month": "0 from Last Month",
  "total-responses-for-july-2021": "Total Responses for July 2021",
  promoter: "Promoter",
  "from-04-sep-2021-to-06-sep-2021": "From 04 Sep,2021 To 06 Sep,2021",
  "the-focus-currently-is-on": "The focus currently is on",
  "1-number-of-customers-have-stated-this-as-an-opportunity":
    "1 number of customers have stated this as an opportunity.",
  "focus-for-the-month": "Focus for the Month",
  "download-pdf": "Download pdf",

  // Report Page New Report
  "total-responses": "Total Responses",
  duration: "Duration",
  "customers-have-stated-this-as-an-opportunity":
    "customers have stated this as an opportunity",
  "error-fetching-params": "Error fetching params!",
  "previous-days-was": "Previous {days} days was {score}",

  // Report Page Common LgCard
  "raised-on": "# Raised on",
  results: "Results",

  // Report Page Components AiSuggestions
  "analyzing-data-please-wait": "Analyzing data, please wait...",

  // Report Page Components CustomerFeedBack
  "view-report": "View Report",
  "received-on": "Received on",

  // Report Page Components ResponseBreakdown
  detractors: "Detractors",
  nps: "NPS",

  // Report Page Components TrendResults
  "trend-results": "Trend Results",

  // Survey helpers Utils
  "failed-to-fetch-the-pdf-file": "Failed to fetch the PDF file",
  "error-generating-pdf-thumbnail": "Error generating PDF thumbnail",
  "error-in-thumbnail-generation-function":
    "Error in thumbnail generation function",
  "failed-to-generate-pdf-thumbnail": "Failed to generate PDF thumbnail",

  // Survey Pages Audition
  "select-audit": "Select Audit",

  // Survey Pages ClientConnect
  "select-atleast-min-options": "Select atleast {minOptions} options",
  "select-max-options": "Maximum {maxOptions} options allowed!",
  "error-saving-your-response": "Error saving your response!",
  "failed-to-load-the-file": "Failed to load the file!",
  "open-link": "Open Link",
  download: "Download",
  details: "Details",
  title: "Title",
  description: "Description",
  "general-info": "General Info",
  type: "Type",
  size: "Size",
  "uploaded-by": "Uploaded by",

  // Survey Pages ClientConnect Intro
  "thank-you-for-your-time": "Thank you for your time!",

  // Survey Pages ClientConnect Content
  "review-content": "Review content",

  // Survey Pages ClientConnect Survey
  "please-give-us-your-feedback": "Please give us your feedback",
  "enter-your-response": "Enter your response",

  // Client Connect v2 (accordion UI)
  "client-connect-preview-hey": "Hello, {name}",
  "client-connect-preview-sent-from": "Sent from {sender} - {date}",
  "client-connect-preview-step-of": "Step {current} of {total}",
  "client-connect-preview-getting-started": "Getting Started",
  "client-connect-preview-getting-started-desc":
    "Take a look at the overview resources prepared for you.",
  "client-connect-preview-share-feedback": "Share Your Feedback",
  "client-connect-preview-share-feedback-desc":
    "Your input helps us build a better experience for you.",
  "client-connect-preview-talk-leadership": "Talk with leadership",
  "client-connect-preview-talk-leadership-desc":
    "Read the message from leadership and save your reply.",
  "client-connect-preview-reviewed-these": "I've reviewed these",
  "client-connect-preview-send-feedback": "Send feedback",
  "client-connect-preview-finish-submit": "Finish & submit",
  "client-connect-preview-save-finish": "Finish & Submit",
  "client-connect-preview-your-reply": "Your reply",
  "client-connect-preview-saved": "Saved",
  "client-connect-preview-edit": "Edit",
  "client-connect-preview-pop-out": "Pop out",
  "client-connect-preview-open": "Open",
  "client-connect-preview-view": "View",
  "client-connect-preview-welcome": "Welcome",
  "client-connect-preview-feedback": "Feedback",
  "client-connect-preview-save-message": "Send Message",
  "client-connect-preview-message-footer":
    "Your message goes directly to the leadership team.",
  "client-connect-preview-leadership-placeholder": "Enter your message...",
  "client-connect-preview-thank-you": "Thank you",
  "client-connect-preview-thank-you-body":
    "You've completed Client Connect. Your survey responses and message have been submitted to the team — they'll be in touch soon.",
  "client-connect-thank-you-message":
    "Thank you for your time. Your feedback truly makes a difference.",
  "client-connect-preview-review-answers": "Review my answers",
  "client-connect-preview-back-dashboard": "Back to dashboard",
  "client-connect-preview-already-submitted":
    "Your feedback has been received. Thank you! Feel free to explore the materials above.",
  "enter-email-address": "Enter email address",
  "enter-phone-no": "Enter phone number",
  "product-type": "Product type",
  "enter-number": "Enter number",
  aspect: "Aspect",

  // Survey Pages ClientConnect Director
  "i-am-constantly-seeking-ways-to-better-our-offerings-for-our-clientele":
    "I am constantly seeking ways to better our offerings for our clientele. Are there aspects we could better in your opinion?",
  "on-another-note-if-there-s-a-specific-topic-you-d-like-our-team-to-address-don-t-hesitate-to-share":
    "On another note, if there's a specific topic you'd like our team to address, don't hesitate to share. I'm not just here to listen, but to engage and act upon your concerns or ideas.",
  "to-provide-enhanced-assistance-we-kindly-ask-for-your-details-including-your-name-email-address-and-contact-number":
    "To provide enhanced assistance, we kindly ask for your details, including your name, email address, and contact number. This information will enable us to respond promptly and contact you.",

  // Survey Pages Location
  "select-the-location-you-visited": "Select the location you visited",
  locations: "Locations",
  "is-this-your-current-location": "Is this your current location?",
  "nearest-location": "Nearest Location",
  "loading-data": "Loading data...",
  "please-wait": "Please Wait!",

  // Survey Pages Location Area
  "location-area": "Location Area",
  "select-location-area": "Select Location Area",

  // Survey Pages Login
  "please-enter-your-password": "Please enter your password",
  "value-must-be-longer-than-3-characters":
    "Value must be longer than 3 characters",
  "please-enter-your-email-address": "Please enter your email address",
  password: "Password",
  "internal-server-error": "Internal Server Error !",
  "sign-in": "Sign In",

  // Survey Pages SameDaySurvey
  "you-have-already-performed-this-survey":
    "You have already performed this survey !",
  "csat-link-invalid": "This survey link is no longer valid.",

  // Survey Pages SurveyThankYou
  "your-feedback-has-been-submitted":
    "Your feedback has been submitted. Your ticket number is #",
  "a-member-of-the-team-will-be-in-touch-shortly":
    "A member of the team will be in touch shortly.",
  "would-you-also-like-to-rate-us-on-google":
    "Would you also like to rate us on Google?",
  "to-review-our-terms-and-conditions-please-click":
    "To review our Terms and Conditions, please click",
  here: "Here",
  "ticket-number-copied-to-clipboard": "Ticket number copied to clipboard",

  // Survey Pages Welcome
  "visit-date": "Visit Date",
  "visit-time-in": "Visit Time In",
  "please-select-date": "Please Select Date",
  "guest-info": "Guest Info",
  "please-select-user": "Please Select User",
  "get-started": "Get Started",

  // Survey Pages InventoryType
  "enter-value": "Enter value",
  "getting-product-list": "Getting Product List...",

  // Survey Pages NotesAndImage
  "upload-file": "Upload File",

  // Survey Pages NumberType
  "enter-digit": "Enter digit",

  // Survey Pages TextArea
  "enter-your-comment": "Enter your comment",

  // Survey Pages Upload
  "file-size-should-be-less-than-10-mb": "File size should be less than 10 MB",
  "drag-you-files-here-file-size-less-than-10-mb-or":
    "Drag you files here, file size less than 10 MB or",
  "upload-or-drag-and-drop-your-files-here":
    "Upload or Drag and Drop your files here",
  "browse-files": "Browse Files",

  // Survey Pages Questions
  "next-question": "Next Question",
  "save-and-exit": "Save and Exit",
  "failed-to-save-and-exit": "Unable to save your progress. Please try again.",
  "progress-saved-you-may-close-this-tab":
    "Your progress has been saved. You may now close this browser tab.",
  "please-enter-at-least": "Please enter at least {min} characters.",
  "contact-no": "Contact No",
  "please-select-location": "Please Select Location!",
  "please-select-survey": "Please Select Survey!",
  "please-enter-your-email-address-or-phone-number":
    "Please enter your email address or phone number.",

  // Utils CompressFiles
  "compression-error": "Compression error:",

  // Web Rating FrontLogin
  "enter-location-id": "Enter Location ID",
  "invalid-location-id": "Invalid Locaiton ID",
  "location-id-required": "Location id required",

  // Web Rating Index
  "please-tell-us-how-your-experience-was-today":
    "Please tell us how your experience was today.",

  // Web Rating Negativefeedback
  "sorry-to-hear-you-didn-t-have-the-best-experience-today-with-us-please-could-you-highlight-what-went-wrong":
    "Sorry to hear you didn't have the best experience today with us, please could you highlight what went wrong?",
  "enter-valid-email-address": "Enter valid email address.",
  "can-we-get-in-touch-with-you": "Can we get in touch with you?",

  // Web Rating Positivefeedback
  "enter-your-telephone-number": "Enter your telephone number",
  "write-your-feedback": "Write your feedback",

  // Web Rating Positivefeedback2
  "what-made-the-employee-name-stand-out-to-you":
    "What made the {employeeName} stand out to you?",
  team: "Team",

  // Web Rating PositivefeedbackForm
  "please-go-to-previous-step-and-select-employee-without-employee-selection-not-able-to-submit-feedback-form":
    "Please go to previous step and select employee, without employee selection not able to submit feedback form",
  "share-us-your-experience-with-us-today":
    "Share us your experience with us today...",
  "did-employee-name-provide-exceptional-service":
    "Did {employeeName} provide exceptional service?",
  "did-employee-name-stand-out-for-delivering-exceptional-service":
    "Did {employeeName} stand out for delivering exceptional service?",

  // Web Rating New apiHelpers loginHelpers
  "please-enter-user-name": "Please enter user name",
  "please-enter-password": "Please enter password",

  // Web Rating New RatingLocations
  search: "Search",
  "select-loction-to-ratings": "Select loction to Ratings",
  location: "Location",
  "is-this-your-location": "Is this your Location?",
  "fetch-details-failed": "Fetch details failed",

  // Web Rating New PositiveJourny EmployeDetail
  "click-as-many-as-you-want": "Click as many as you want",
  "what-made-employee-name-stand-out-to-you":
    "What made {employeeName} stand out to you?",
  "what-made-the-team-stand-out-to-you": "What made the team stand out to you?",

  // Web Rating New PositiveJourny EmployeService
  "did-we-stand-out-for-delivering-exceptional-service":
    "Did we stand out for delivering exceptional service?",

  // Web Rating New NegativeJourny EmployePersonalDetail
  "leave-an-email-or-phone-number-if-you-want-us-to-get-in-touch-otherwise-just-leave-it-blank-then-press-next":
    "Leave an email or phone number if you want us to get in touch, otherwise just leave it blank then press next",
  "anything-else-you-d-like-to-share": "Anything else you’d like to share?",
  "enter-valid-email": "Enter valid email",
  message: "Message",
  "by-signing-up-the-form-you-agree-to-our-terms-and-privacy":
    "By signing up the form, you agree to our Terms and Privacy.",

  // Web Rating New FrontWebLogin
  login: "Login",
  username: "Username",

  // Web Rating New FrontRating
  "press-the-facial-expression-that-best-represents-how-you-feel-about-your-experience":
    "Press the facial expression that best represents how you feel about your experience.",
  "getting-employee-list": "Getting employee list",
  "getting-skill-data": "Getting skill data",
  "getting-screen-saver": "Getting screen saver",

  // Web Rating New CommonComponents ThankYouModal
  "thank-you-for-contacting-us": "Thank You for contacting us.",
  "we-ll-be-in-touch-very-soon": "We’ll be in touch very soon.",

  // Web Rating New CommonComponents GoogleQrPage
  "you-can-follow-this-button-to-rate-us-on-google":
    "You can follow this button to rate us on Google",
  "rate-us-on-google": "Rate us on Google",

  // Web Rating New CommonComponents ContactUsModal
  "contact-us": "Contact Us",
  "or-you-may-reach-us-on": "...or you may reach us on.",
  "do-you-want-to-learn-more-about-serve-first":
    "Do you want to learn more about Serve First?",

  // Web Rating New CommonComponents BottomBar
  saving: "Saving",
  "please-enter-only-digits-for": "Please enter only digits for",
  "please-enter": "Please enter",
  "enter-value-here": "Enter value here",

  // Survey Pages Questions Dropdown
  "please-select": "Please select",
  "survey-retry-message":
    "You will be able to perform this survey after {value} {unit}.",
  minute: "minute",
  minutes: "minutes",
  hour: "hour",
  hours: "hours",
  day: "day",
  days: "days",
  week: "week",
  weeks: "weeks",
  month: "month",
  months: "months",
  clear: "Clear",

  "powered-by": "Powered by",
  "image-is-required": "Image is required",
  "please-fill-all-required-contact-information":
    "Please fill all required contact information",

  "please-leave-any-extra-feedback-in-the-box-below":
    "Please leave any extra feedback in the box below.",
  "all-feedback-is-confidential": "All feedback is confidential",
  "your-feedback-has-been-received-thank-you":
    "Your feedback has been received, thank you",
  "close-page": "Close page",
  send: "Send",
  sending: "Sending",
  "enter-your-feedback-here": "Enter your feedback here",
  "for-anything-else-please": "For anything else please ",
  "please-correct-the-custom-field-values":
    "Please correct the custom field values",
  "please-complete-all-required-contact-information":
    "Please complete all required contact information",
  "survey-cannot-be-submitted": "Survey cannot be submitted",
  "please-enter-your-phone": "Please enter your phone",
  "network-error-please-try-again":
    "Network error. Please check your connection and try again.",
  "no-results-found": "No results found",
  "drop-files-here": "Drop the files here...",
  "drag-drop-files": "Drag 'n' drop some files here, or click to select files",
  "max-5-files-5mb": "Max 5 files, 5MB each, images only",
  remove: "Remove",

  // Learning & Development

  "ld-module-title": "Learning & Development",
  "ld-no-sign-in-required": "No sign-in required",
  "ld-progress-warning":
    "Please don't close this window — your progress isn't saved and you'd need to start over.",
  "ld-loading-module": "Loading learning module…",
  "ld-unable-load-module": "Unable to load learning module.",
  "ld-package-not-configured": "Learning package is not configured.",
  "ld-start-guidance": "Start training",
  "ld-due-date": "Due {date}",
  "ld-whats-involved": "What's involved",
  "ld-your-progress": "YOUR PROGRESS",
  "ld-step-of": "Step {current} of {total}",
  "ld-watched-in-full": "Watched in full",
  "ld-video-no-skip": "You can rewind, but not skip ahead",
  "ld-video-muted-counts": "Muted — playback still counts",
  "ld-maximize-document": "Maximize document",
  "ld-minimize-document": "Minimize document",
  "ld-read-percent": "{percent}% read",
  "ld-end-of-document": "End of document",
  "ld-scroll-to-continue": "Scroll to continue",
  "ld-read-to-end": "Read to the end",
  "ld-read-to-end-to-continue": "Read to the end to continue",
  "ld-loading-document": "Loading document…",
  "ld-pdf-preview-unavailable": "Unable to preview this PDF in the browser.",
  "ld-pdf-page-alt": "{title} — page {page}",
  "ld-knowledge-check": "KNOWLEDGE CHECK",
  "ld-knowledge-check-title": "{title} — knowledge check",
  "ld-quiz-instruction":
    "Answer all {count, plural, one {# question} other {# questions}}. Pass mark {passMark}%.",
  "ld-quiz-instruction-pass-only": "Pass mark {passMark}%.",
  "ld-question-of": "QUESTION {current} OF {total}",
  "ld-guidance-of": "TRAINING {current} OF {total}",
  "ld-loading-questionnaire": "Loading questionnaire…",
  "ld-preparing-questions": "Preparing your questions",
  "ld-submit-answers": "Submit answers",
  "ld-submitting": "Submitting…",
  "ld-ready-to-submit": "Ready to submit your answers",
  "ld-answer-selected": "Answer selected",
  "ld-select-answer": "Select one answer to continue",
  "ld-pass-mark-note":
    "You need {passMark}% or higher to pass. Answers can't be changed once submitted.",
  "ld-questionnaire-not-configured": "Questionnaire is not configured.",
  "ld-unable-load-questionnaire": "Unable to load questionnaire.",
  "ld-no-visible-questions":
    "No questions are available for this knowledge check right now.",
  "ld-unable-submit-answers": "Unable to submit answers. Please try again.",
  "ld-not-passed": "Not passed",
  "ld-completed": "Completed",
  "ld-fail-title": "Just missed the mark — give it another go",
  "ld-fail-description":
    "You scored {score} — the pass mark is {passMark}%. You have {remaining} remaining.",
  "ld-attempts-remaining":
    "{count, plural, one {# attempt} other {# attempts}}",
  "ld-attempt-of": "Attempt {current} of {total}",
  "ld-fail-alert":
    "Take a moment to review the guidance again, then re-take the check. After your final attempt the check will lock.",
  "ld-try-again": "Try again",
  "ld-review-guidance": "Review guidance",
  "ld-locked-title": "This training is now locked",
  "ld-locked-description":
    "You scored {score} — the pass mark for this package is {passMark}%. For compliance reasons you can't retake it here.",
  "ld-speak-to-manager": "Speak to your manager",
  "ld-locked-manager-copy":
    "Your duty manager can re-issue {courseTitle} so you can work through the guidance again and re-attempt the check.",
  "ld-close-window": "You can now close this window.",
  "ld-close-window-safe": "You can now safely close this window.",
  "ld-success-title": "Congratulations!",
  "ld-success-description":
    "You've successfully completed {courseTitle}. This has been recorded against your training profile — there's nothing more to do.",
  "ld-email-yourself": "Email yourself a copy",
  "ld-email-copy-description":
    "Send a confirmation of completion to your inbox for your records.",
  "ld-email-placeholder": "you@company.com",
  "ld-sent": "Sent",
  "ld-sending-email": "Sending…",
  "ld-unable-send-email": "Unable to send email. Please try again.",
  "ld-email-sent-success": "Completion email sent successfully!",
  "ld-video-briefing": "Video briefing",
  "ld-document": "Document",
  "ld-video-meta": "Video",
  "ld-video-meta-no-skip": "Video · no skip",
  "ld-document-meta": "Document · PDF",
  "ld-document-meta-scroll": "Document · PDF · scroll to end",
  "ld-video-instruction-full": "Watch in full — you cannot skip ahead",
  "ld-video-instruction": "Watch the briefing, then continue",
  "ld-document-instruction-scroll": "Scroll to the end to continue",
  "ld-document-instruction": "Review the document, then continue",
  "ld-questionnaire": "Questionnaire",
  "ld-confirmation": "Confirmation",
  "ld-question-count": "{count, plural, one {# question} other {# questions}}",
  "ld-knowledge-check-subtitle": "Knowledge check",
  "ld-score": "Score",
  "ld-whats-involved-pass-mark":
    "Pass mark {passMark}% · unlocks after guidance",
  "ld-document-type-pdf": "{documentType} · PDF",
};
